import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { ROUTE_DAYS } from './constants';

const DaysLinks = (props) => (
    <div className="tb-form__days">
        <Link className="tb-form__days-link" to={ROUTE_DAYS}>
            <span className="visually-hidden">Select days</span>
            <svg className="tb-form__icon-calendar" width="17" height="18" focusable="false">
                <use xlinkHref="#icon-calendar"></use>
            </svg>
        </Link>
        <div className="tb-days-list">
            {props.productGroupsList.map((productGroup) => (
                <Link
                    className="tb-days-list__link"
                    to={ROUTE_DAYS}
                    key={productGroup.id}
                >{productGroup.title}</Link>
            ))}
        </div>
    </div>
);

DaysLinks.propTypes = {
    productGroupsList: PropTypes.array
};

export default DaysLinks;
